import get from 'lodash/get';
import React from 'react';
import { FieldError, FieldValues, FieldErrors } from 'react-hook-form';
import * as yup from 'yup';

/**
 * Helper hook to construct a react hook form validation resolver
 * from yup schema validation object
 */
export function useYupValidationResolver(
  validationSchema: yup.ObjectSchema<any>
) {
  return React.useCallback(
    async (data: any) => {
      try {
        const values = await validationSchema.validate(data, {
          abortEarly: false,
        });

        return {
          values,
          errors: {},
        };
      } catch (errors: any) {
        return {
          values: {},
          errors: errors.inner.reduce(
            (allErrors: FieldError[], currentError: any) => ({
              ...allErrors,
              [currentError.path]: {
                type: currentError.type ?? 'validation',
                message: currentError.message,
              },
            }),
            {}
          ),
        };
      }
    },
    [validationSchema]
  );
}

/**
 * Helper routine to propagate react hook form messages into `<TextField/>`
 * components
 */
export function muiError<T extends FieldValues>(
  errors: FieldErrors<T>,
  path: string
) {
  const msg = get(errors, `${path}.message`) as string | undefined;
  return {
    error: !!msg,
    helperText: msg,
  };
}
